// extracted by mini-css-extract-plugin
module.exports = {"higpp-l-login-box-loading":"Loading_higpp-l-login-box-loading__1MECz"};